import { useMemo } from "react";
import { useDesignPropertyShortcuts } from "@/components/Canvas/hooks/useDesignPropertyShortcuts";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

export const useTextTypographyShortcuts = () => {
  const {
    applyBold,
    applyItalic,
    applyUnderline,
    applyStrikethrough,
    applyAlignLeft,
    applyAlignCenter,
    applyAlignRight,
    applyAlignJustify,
  } = useDesignPropertyShortcuts();

  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "mod+b": {
        handler: applyBold,
        description: "Toggle bold",
      },
      "mod+i": {
        handler: applyItalic,
        description: "Toggle italic",
      },
      "mod+u": {
        handler: applyUnderline,
        description: "Toggle underline",
      },
      "mod+shift+x": {
        handler: applyStrikethrough,
        description: "Toggle strikethrough",
      },
      "mod+alt+l": {
        handler: applyAlignLeft,
        description: "Text align left",
      },
      "mod+alt+t": {
        handler: applyAlignCenter,
        description: "Text align center",
      },
      "mod+alt+r": {
        handler: applyAlignRight,
        description: "Text align right",
      },
      "mod+alt+j": {
        handler: applyAlignJustify,
        description: "Text align justified",
      },
    }),
    [
      applyBold,
      applyItalic,
      applyUnderline,
      applyStrikethrough,
      applyAlignLeft,
      applyAlignCenter,
      applyAlignRight,
      applyAlignJustify,
    ],
  );

  useKeyboardShortcuts({ shortcuts });
};
